import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ticket-purchased-confirm',
  templateUrl: './ticket-purchased-confirm.component.html'
})
export class TicketPurchasedConfirmDialog {
  settingsData: any = {};

  constructor(
    public dialogRef: MatDialogRef<TicketPurchasedConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.settingsData = data?.settingsData || {};
  }

  continue(status: string) {
    this.dialogRef.close(status);
  }
}
